export const supportAgentName = (agent) =>
  [agent?.attributes?.first_name, agent?.attributes?.last_name]
    .filter(Boolean)
    .join(" ");

// Callers hold the id as a number (inbox threads) or a string (ticket
// relationships), so ids are compared as strings.
export const findSupportAgent = (supportAgents, supportAgentId) =>
  supportAgentId === null || supportAgentId === undefined
    ? undefined
    : supportAgents?.find(
        (agent) => String(agent.id) === String(supportAgentId)
      );

// An assignee outside the agent list may come without a name, and a blank
// label would read as unassigned.
export const supportAgentLabel = (agent, supportAgentId) =>
  supportAgentName(agent) || `Agent #${supportAgentId}`;

// Sorted by the name shown, ignoring case and accents, so the dropdowns read
// alphabetically however the API happens to order the agents.
export const sortSupportAgentsByName = (supportAgents) =>
  [...(supportAgents ?? [])].sort((a, b) =>
    supportAgentName(a).localeCompare(supportAgentName(b), undefined, {
      sensitivity: "base",
    })
  );
